import { apiUrl } from "./apiBase";
import { createSessionTransport } from "./sessionTransport";
export { SessionUnavailableError, SessionEndedError } from "./sessionTransport";
const transport = createSessionTransport({
  name: "pd",
  me: () => apiUrl("/v1/auth/me"),
  refresh: () => apiUrl("/v1/auth/mfa/refresh"),
  owns: (url) =>
    url.origin ===
      new URL(
        apiUrl("/v1/auth/me"),
        typeof location === "undefined" ? "http://localhost" : location.origin,
      ).origin && /^\/v\d+\//.test(url.pathname),
  isPublic: (path, headers) =>
    [
      "/v1/auth/login",
      "/v1/auth/config",
      "/v1/auth/send-password",
      "/v1/auth/verify",
      "/v1/auth/totp-login",
      "/v1/auth/mfa/refresh",
      "/v1/auth/mfa/logout",
      "/v1/auth/mfa/methods",
      "/v1/auth/mfa/webauthn/discover/options",
      "/v1/auth/mfa/webauthn/discover/verify",
    ].includes(path) ||
    // Pre-MFA bearer credentials belong to the sign-in flow, not cookie recovery.
    (path.startsWith("/v1/auth/mfa/") && headers.has("Authorization")) ||
    path.startsWith("/v1/alpaca-broker"),
  endsSession: (path) => path === "/v1/auth/mfa/logout",
  changesSession: (path) =>
    /^\/v1\/auth\/(mfa\/logout|verify|totp-login|impersonate|stop-impersonate|mfa\/verify|email-change-verify|mfa\/webauthn\/(register|authenticate|discover)\/verify)$/.test(
      path,
    ),
});
export const sessionFetch = transport.sessionFetch;
export const recoverSession = transport.recover;
export const sessionVersion = transport.version;
export const assertSessionCurrent = transport.assertCurrent;

export const subscribeToSessionChanges = transport.subscribeToChanges;
